export class MachineParkFilters {
  organizationUuids: string[];
}
